import { startPolygonChecks, type BasemapUrls } from '@agribot/polygon-checks-ui'
import '@agribot/polygon-checks-ui/styles.css'
import { SignIn, fullEdition, getAccessToken, loadAccessToken, signOut } from '@agribot/polygon-checks-admin'
import { sourcingSection } from '@agribot/buyer-workspace'

// Ours: the application with the admin section, signing in with Auth0 (a
// session cookie, hence `include`) or a token kept in this browser. A
// partner's (partner-web/) renders the same component inside their own app.
loadAccessToken()

/**
 * Basemap tiles fetched straight from their provider, set at build time
 * (VITE_BASEMAP_LIGHT_URL, …_LABELS_URL, …_SATELLITE_URL). Unset, a style's
 * tiles come through the API's proxy. Only keyless tiles or a key the
 * provider restricts to this site's domain: these end up in the bundle.
 */
// Each read spelled out: Vite replaces `import.meta.env.NAME` at build time
// only where it is written literally.
const basemaps: BasemapUrls = Object.fromEntries(Object.entries({
  light: import.meta.env.VITE_BASEMAP_LIGHT_URL as string | undefined,
  labels: import.meta.env.VITE_BASEMAP_LABELS_URL as string | undefined,
  satellite: import.meta.env.VITE_BASEMAP_SATELLITE_URL as string | undefined,
}).filter(([, url]) => url))

startPolygonChecks(document.getElementById('root')!, {
  apiUrl: import.meta.env.VITE_API_URL ?? 'http://localhost:4000',
  credentials: 'include',
  basemaps,
  getToken: getAccessToken,
  signedOut: <SignIn />,
  onSignOut: signOut,
  // The buyer's sourcing workspace (review queues) beside our admin section.
  edition: { ...fullEdition, sections: [sourcingSection()] },
  version: __APP_VERSION__,
})
